export const HttpConst = {
    headers : {
        'Content-Type': 'application/json'
    }
};
